import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  IconButton,
  Spinner,
  Select,
  Icon,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCircle, FaAlignJustify, FaArrowLeft } from "react-icons/fa";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useSetRecoilState } from "recoil";
import moment from "moment";
import ListaBoletoAPI from "../../../services/ListaBoleto";
import SystemApi from "../../../services/systemApi";
import PermissionsAPI from "../../../services/permissionsAPI";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { componentState } from "../../../atoms/componentState";
import { LoggedUser } from "../../../atoms/userLogged";
import { customColors } from "../../../atoms/customColors";
import { permissions } from "../../../atoms/permissions";
import Pagination from "../../../defaultComponents/pagination";
import DateDropdownDeafult from "../../../defaultComponents/dateDropdown";
import ModalDetailVendaBoleto from "./components/ModalDetailVendaBoleto";
import LoteStatusProgresso from "./components/LoteStatusProgresso";

interface objetoSalesList {
  id: string;
  idCliente: number;
  bandeira: string;
  clienteNome: string | null;
  cnpj: string;
  dataCriacao: string;
  dataExpiracao: string | null;
  dataPagamento: string | null;
  isCnpj: boolean;
  nomeFantasia: string;
  razaoSocial: string;
  status: string;
  taxaCliente: number;
  taxaPlano: number;
  valor: number;
  valorLiquido: number;
  barcode?: string;
  emv?: string;
  mensagem?: string;
  idLote?: string;
}

interface statusInfo {
  id: number;
  status: string;
}

interface JWTToken {
  primarysid: string;
  name: string;
  email: string;
  exp: number;
  idCliente: number;
  loginPermissoes: string;
}

export default function BatchBoletosList() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState<objetoSalesList[]>([]);
  const [openDetails, setOpenDetails] = useState(false);
  const [details, setDetails] = useState<objetoSalesList | {}>({});
  const [statusList, setStatusList] = useState<statusInfo[]>([]);
  const [permissionsList, setPermissionsList] = useState<Array<any>>([]);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const safeDate = (date?: string): string => date || "";
  const [colors] = useRecoilState(customColors);
  const [user] = useRecoilState(LoggedUser);
  const setPermsRecoil = useSetRecoilState(permissions);
  const token = window.localStorage.getItem("token");
  const jwtToken: JWTToken = jwt_decode(token || "");
  const navigate = useNavigate();
  const setHeaderLocation = useSetRecoilState(componentState);
  const { idLote } = useParams<{ idLote: string }>();

  const initialValues = {
    statusFilter: 0,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);

  async function fetchPermissions(id: string) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setPermsRecoil(response);
      setIsNotEmpty(response.length > 0);
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Erro ao carregar permissões!");
    }
  }

  let loginPermissoes: number[] = [];
  if (token && typeof token === "string" && token.includes(".")) {
    try {
      const decoded: JWTToken = jwt_decode(token);
      if (decoded.loginPermissoes) {
        loginPermissoes = JSON.parse(decoded.loginPermissoes);
      }
    } catch (error) {
      console.error("Error decoding JWT or parsing loginPermissoes:", error);
    }
  }

  useEffect(() => {
    if (permissionsList.length === 0 && !isNotEmpty && jwtToken.idCliente) {
      fetchPermissions(String(jwtToken.idCliente));
    }
  }, [permissionsList, jwtToken.idCliente]);

  function temPermissao(
    userPerm: number | null,
    clientePerm: boolean,
    permArray: number[] = []
  ): boolean {
    if (!permArray.length || userPerm === null) {
      return clientePerm ?? false;
    }
    const permUser = permArray.includes(userPerm);
    const permCliente = clientePerm ?? false;
    return permUser && permCliente;
  }

  const hasBolePixPermission = temPermissao(
    44,
    permissionsList.some((perm: any) => perm.idPermissoes === 44),
    loginPermissoes
  );

  async function getBoletosByLote() {
    if (!idLote) {
      toast.error("ID do lote não fornecido!");
      return;
    }
    try {
      setLoading(true);
      const response = await ListaBoletoAPI.getBolepix(
        currentPage,
        pageSize,
        Number(jwtToken.idCliente),
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.statusFilter,
        5,
        false,
        safeDate(filtros.initialDateFilter),
        safeDate(filtros.finalDateFilter),
        idLote,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined
      );

      const mappedSales: objetoSalesList[] = response.data.map((item: any) => ({
        id: item.id,
        idCliente: item.idCliente,
        bandeira: item.transacao?.bandeira || "N/A",
        clienteNome: item.transacao?.clienteNome || "N/A",
        cnpj: item.transacao?.cnpj || "N/A",
        dataCriacao: item.transacao?.dataCriacao || item.criadoEm || "",
        dataExpiracao:
          item.transacao?.dataExpiracao || item.dataVencimento || null,
        dataPagamento: item.transacao?.dataPagamento || null,
        isCnpj: item.transacao?.isCnpj || false,
        nomeFantasia: item.transacao?.nomeFantasia || "N/A",
        razaoSocial: item.transacao?.razaoSocial || "N/A",
        status:
          item.transacao?.status ||
            (item.transacao == null && item.idTransacao != null)
            ? "generated"
            : "unknown",
        taxaCliente: item.transacao?.taxaCliente || 0,
        taxaPlano: item.transacao?.taxaPlano || 0,
        valor:
          item.transacao?.valor ||
          parseFloat(item.valor?.replace(",", ".")) ||
          0,
        valorLiquido: item.transacao?.valorLiquido || 0,
        barcode: item.barcode || "N/A",
        emv: item.emv || "N/A",
        mensagem: item.mensagem || "N/A",
        idLote: item.idLote || idLote,
      }));

      setSalesList(mappedSales);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
    } catch (error) {
      console.error("Error fetching boletos by lote:", error);
      toast.error("Erro ao carregar a lista de boletos do lote!");
    } finally {
      setLoading(false);
    }
  }

  async function getStatusList() {
    try {
      const response = await SystemApi.getTransacoesStatus();
      setStatusList(response);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  }

  useEffect(() => {
    setHeaderLocation(`Boletos do Lote ${idLote || ""}`);
    getStatusList();
  }, []);

  useEffect(() => {
    getBoletosByLote();
  }, [
    idLote,
    search,
    currentPage,
    pageSize,
    filtros.statusFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
  ]);

  const statusOptions = statusList.map((item) => ({
    key: item.id,
    value: item.id,
    text: item.status,
  }));

  const onChangeStatusFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
    setCurrentPage(1);
  };

  const onChangeSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "succeeded":
        return colors.GREENMONEDD;
      case "pending":
        return colors.YELLOWMONEDD;
      case "failed":
        return colors.ORANGEMONEDD;
      case "new":
        return colors.GRAYCARD;
      case "chargeback":
        return colors.REDCARD;
      case "canceled":
        return colors.REDMONEDD;
      case "generated":
        return colors.YELLOWMONEDD;
      default:
        return colors.GRAY;
    }
  };

  const renderTable = () => (
    <TableContainer
      maxWidth="100%"
      overflowX="auto"
      overflowY="auto"
      maxHeight="55vh"
    >
      <Table
        variant="simple"
        size="md"
        colorScheme="gray"
        width="100%"
        minWidth="1400px"
      >
        <Thead>
          <Tr>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopLeftRadius="md"
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Data
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="150px"
              whiteSpace="nowrap"
            >
              EC
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Status
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="120px"
              whiteSpace="nowrap"
            >
              Vencimento
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              minWidth="100px"
              whiteSpace="nowrap"
            >
              Valor Total
            </Th>
            <Th
              bgColor={colors.BLUEMONEDDBACKGROUND}
              color={colors.WHITE}
              borderTopRightRadius="md"
              minWidth="80px"
              whiteSpace="nowrap"
              position="sticky"
              right={0}
              zIndex={1}
              bg={colors.BLUEMONEDDBACKGROUND}
            >
              Opções
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {salesList.length === 0 ? (
            <Tr>
              <Td colSpan={6} textAlign="center">
                Nenhum boleto encontrado
              </Td>
            </Tr>
          ) : (
            salesList.map((item, index) => (
              <Tr
                key={index}
                _hover={{ bg: colors.GRAY_LIGHTEST }}
                transition="background 0.2s"
              >
                <Td whiteSpace="nowrap">
                  {item.dataCriacao
                    ? moment(item.dataCriacao).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {item.isCnpj
                    ? item.razaoSocial || "-"
                    : `${item.razaoSocial || "-"} ${item.nomeFantasia || ""}`}
                </Td>
                <Td whiteSpace="nowrap">
                  <Flex alignItems="center">
                    <Icon
                      as={FaCircle}
                      color={getStatusColor(item.status)}
                      boxSize={3}
                      mr={2}
                    />
                    {item.status === "succeeded" && "Sucesso"}
                    {item.status === "pending" && "Pendente"}
                    {item.status === "failed" && "Falhou"}
                    {item.status === "new" && "Nova"}
                    {item.status === "chargeback" && "ChargeBack"}
                    {item.status === "canceled" && "Cancelado"}
                    {item.status === "unknown" && "A ser gerado"}
                    {item.status === "generated" && "Boleto Gerado"}
                    {![
                      "succeeded",
                      "pending",
                      "failed",
                      "new",
                      "chargeback",
                      "canceled",
                      "unknown",
                      "generated",
                    ].includes(item.status) && item.status}
                  </Flex>
                </Td>
                <Td whiteSpace="nowrap">
                  {item.dataExpiracao
                    ? moment(item.dataExpiracao).format("DD/MM/YYYY HH:mm")
                    : "-"}
                </Td>
                <Td whiteSpace="nowrap">
                  {(item.valor ?? 0).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Td>
                <Td
                  whiteSpace="nowrap"
                  position="sticky"
                  right={0}
                  zIndex={1}
                  bg={colors.WHITE}
                >
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      aria-label="Options"
                      icon={<HamburgerIcon />}
                      bgColor={colors.BLUEMONEDDBUTTONS}
                      color={colors.WHITE}
                      size="sm"
                      _hover={{ bgColor: colors.BLUEMONEDDRGB2 }}
                      _active={{ bgColor: colors.BLUEMONEDDBACKGROUND }}
                      transition="all 0.2s"
                    />
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          setOpenDetails(true);
                          setDetails(item);
                        }}
                        _hover={{ bg: colors.GRAY_LIGHT }}
                      >
                        <Flex alignItems="center">
                          Visualizar Detalhes
                          <Icon
                            as={FaAlignJustify}
                            color={colors.BLUEMONEDDBUTTONS}
                            boxSize={4}
                            ml={2}
                          />
                        </Flex>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Td>
              </Tr>
            ))
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );

  return (
    <Flex
      flexDir="column"
      height="90vh"
      width="100%"
      bgColor={colors.GRAY_LIGHTEST}
      p={8}
      overflow="hidden"
    >
      <Box mb={8} bg={colors.WHITE} borderRadius="lg" boxShadow="md" p={6}>
        <Flex alignItems="center" mb={6}>
          <Button
            bgColor="transparent"
            color={colors.BLUEMONEDDBUTTONS}
            size="md"
            onClick={() => navigate("/vendas/bolepix")}
            leftIcon={<FaArrowLeft />}
            _hover={{ color: colors.BLUEMONEDDRGB2 }}
            transition="all 0.2s"
            mr={3}
          >
            Voltar
          </Button>
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color={colors.BLUEMONEDDBACKGROUND}
          >
            Boletos do Lote {idLote || ""}
          </Text>
        </Flex>
        <Flex flexWrap="wrap" gap={4} alignItems="center">
          <Select
            placeholder="Filtrar por Status"
            maxW="250px"
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <DateDropdownDeafult filtros={filtros} setFiltros={setFiltros} />
          <Button
            bgColor={colors.GRAY_DARK}
            color={colors.WHITE}
            size="md"
            onClick={() => setFiltros(initialValues)}
            _hover={{ bgColor: colors.GRAY_DARKEST }}
            _active={{ bgColor: colors.GRAY_DARKER }}
            transition="all 0.2s"
          >
            Limpar Filtros
          </Button>
        </Flex>
      </Box>

      {idLote && (
        <Box mb={6} bg={colors.WHITE} borderRadius="lg" boxShadow="md" p={6}>
          <Text
            fontSize="lg"
            fontWeight="bold"
            color={colors.BLUEMONEDDBACKGROUND}
            mb={3}
          >
            Progresso da Geração
          </Text>
          <LoteStatusProgresso idLote={idLote} compact />
        </Box>
      )}

      <Box
        flex="1"
        bg={colors.WHITE}
        borderRadius="lg"
        boxShadow="md"
        p={6}
        overflow="visible"
      >
        {loading ? (
          <Flex h="50vh" alignItems="center" justifyContent="center">
            <Spinner
              size="xl"
              color={colors.BLUEMONEDDBUTTONS}
              thickness="4px"
            />
          </Flex>
        ) : (
          renderTable()
        )}
        <Flex justifyContent="center" alignItems="center" mt={6} gap={4}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            width="80px"
            bg={colors.WHITE}
            borderColor={colors.GRAY_LIGHTER}
            _focus={{ borderColor: colors.BLUEMONEDDBUTTONS }}
            _hover={{ borderColor: colors.BLUEMONEDDRGB2 }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
        <ModalDetailVendaBoleto
          isOpen={openDetails}
          setIsOpen={setOpenDetails}
          item={details}
        />
      </Box>
    </Flex>
  );
}
